export const isValidEmail = (email: string) => {
  return !!email.toLowerCase().match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
}

export const isValidUrl = (url?: string): boolean => {
  try {
    const newUrl = new URL(url ?? '')
    return true
  } catch (error) {
    return false
  } 
}